import { Button } from '@kanda-libs/ks-design-library';
import { Link } from 'react-router-dom';

import { CLASS_NAMES, LOGIN_BUTTON, SSO_BUTTON } from './constants';

import {
  AppleSignupButton,
  FacebookSignupButton,
  GoogleSignupButton,
} from '../../../../components';
import { URLS } from '../../../../config';
import useLoginFooter from './useLoginFooter';

export interface LoginFooterProps {
  /**
   * Disabled state for login button
   */
  disabled?: boolean;
  /**
   * Disabled state for social buttons
   */
  socialDisabled?: boolean;
  /**
   * Function to sign in with Google
   */
  signInWithGoogle?(...args: unknown[]): unknown;
  /**
   * Function to sign in with FB
   */
  signInWithFb?(...args: unknown[]): unknown;
  /**
   * Function to sign in with FB
   */
  signInWithApple?(...args: unknown[]): unknown;
}

const LoginFooter: React.FunctionComponent<LoginFooterProps> = function ({
  disabled,
  socialDisabled,
  signInWithGoogle,
  signInWithFb,
  signInWithApple,
}) {
  const { showSocial } = useLoginFooter();
  return (
    <div className={CLASS_NAMES.container}>
      <Button.Text {...LOGIN_BUTTON} disabled={disabled} />
      {showSocial && (
        <>
          <div className={CLASS_NAMES.socialContainer}>
            <GoogleSignupButton
              socialDisabled={socialDisabled}
              signInWithGoogle={signInWithGoogle}
            />
            <FacebookSignupButton
              socialDisabled={socialDisabled}
              signInWithFb={signInWithFb}
            />
          </div>
          <div className="w-full md:w-1/2 mx-auto mt-4">
            <AppleSignupButton
              socialDisabled={socialDisabled}
              signInWithApple={signInWithApple}
            />
          </div>
        </>
      )}
      <Link to={URLS.loginSso} className="mx-auto">
        <Button.Link {...SSO_BUTTON} />
      </Link>
    </div>
  );
};

export default LoginFooter;
